export default __webpack_public_path__ + "0e51eed79323c91e1cb96980e60de3c7.svg";